import { render, staticRenderFns } from "./BrokerTable.vue?vue&type=template&id=7972c6af&"
import script from "./BrokerTable.vue?vue&type=script&lang=ts&"
export * from "./BrokerTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports